import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Fields } from '../../components/Fields';
import CTLogo from '../../assets/svg/ctLogo';
import { authService } from './authService';
import './Login.css';

// Constants
const Status = {
  LOADING: 'LOADING',
  AUTHENTICATED: 'AUTHENTICATED'
};

const CalloutTypes = {
  ERROR: 'error'
};

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@cleartrip\.com$/;
  return emailRegex.test(email);
};
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [credential, setCredential] = useState({
    username: '',
    password: ''
  });
  const [validEmail, setValidEmail] = useState(true);
  const [error, setError] = useState('');
  const [user, setUser] = useState({ status: Status.LOADING });

  // Check if user is already authenticated
  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/campaigns');
    }
  }, [navigate]);

  const handleUsernameChange = (payload) => {
    const newUsername = payload.valueConfig.selectedValues[0];
    setCredential(prev => ({
      ...prev,
      username: newUsername
    }));
    setValidEmail(validateEmail(newUsername));
    setError('');
  };

  const handlePasswordChange = (payload) => {
    setCredential(prev => ({
      ...prev,
      password: payload.valueConfig.selectedValues[0]
    }));
    setError('');
  };

  const handleLogin = async () => {
    if (validateEmail(credential?.username)) {
      setValidEmail(true);
      try {
        const response = await authService.login(credential);
        console.log('Login response:', response); // Debug log

        if (response.status === 200 && response.data?.response) {
          const { response: userData } = response.data;
          setUser({
            status: Status.AUTHENTICATED,
            ...userData,
            selectedTeam: userData.teamDetails[0] || {}
          });
          // Redirect to the attempted URL or default to campaigns
          const from = location.state?.from?.pathname || '/campaigns';
          navigate(from, { replace: true });
        } else {
          // Handle different error cases
          if (response.status === 403) {
            setError('Access denied. Please check your credentials.');
          } else if (response.status === 401) {
            setError('Invalid username or password.');
          } else {
            setError(response.data?.message || 'Authentication failed. Please try again.');
          }
          alert(error);
        }
      } catch (e) {
        console.error('Login error:', e);
        if (e.message === 'Failed to fetch') {
          setError('Unable to connect to the server. Please check your internet connection.');
        } else {
          setError('Something went wrong. Please try again.');
        }
      }
    } else {
      setValidEmail(false);
    }
  };

  const errorMessageClass = 'fs-12 lh-16 c-error-500 mt-1';

  return (
    <div className="flex flex-1 flex-center flex-middle">
      <form 
        className="login-box bg-neutral-100 br-12"
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
        autoComplete="on"
      >
        <div className="flex flex-center mt-12">
          <div className="mt-1 d-inline-block">
            <CTLogo height={20} width={20} />
          </div>
          <span className="fw-600 fs-24 lh-32 ml-2 c-primary-500">
            Coupon Engine
          </span>
        </div>
        <div className="w-100p mt-6">
          <Fields
            fieldType="TEXT_INPUT"
            valueConfig={{
              selectedValues: [credential.username],
              validation: { mandatoryField: true }
            }}
            displayAttributes={{
              displayName: 'LDAP username',
              placeholderText: 'example@cleartrip.com',
              autoComplete: 'username',
              name: 'username'
            }}
            onChangeCallback={handleUsernameChange}
            onErrorCallback={(hasError) => setValidEmail(!hasError)}
          />
          {!validEmail && (
            <div className={errorMessageClass}>Enter a valid email address</div>
          )}
        </div>
        <div className="w-100p mt-6">
          <Fields
            fieldType="TEXT_INPUT"
            valueConfig={{
              selectedValues: [credential.password],
              validation: { mandatoryField: true }
            }}
            displayAttributes={{
              displayName: 'LDAP password',
              placeholderText: 'Enter your password',
              type: 'password',
              autoComplete: 'current-password',
              name: 'password'
            }}
            onChangeCallback={handlePasswordChange}
            onErrorCallback={() => {}}
          />
        </div>
        <div className="w-100p mt-12">
          <Button
            size="lg"
            type="submit"
            onClick={()=>{handleLogin()}}

            color="secondary"
            className="flex flex-middle flex-center w-100p"
            disabled={false}
          >
            Login
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Login; 